var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"app-button",class:[
           ("app-button_" + _vm.size),
           ("app-button_" + _vm.type),
           ("app-button_" + _vm.color),
           {
             'app-button_icon-only': !_vm.$slots.default
           }
        ],on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('span',{staticClass:"app-button__icon"},[_c('app-icon',{attrs:{"name":_vm.icon,"size":"1.28rem"}})],1):_vm._e(),_c('span',{staticClass:"app-button__text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }